module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_theboms_m.7f2a56e080e66fe8b908fadc068fa52f.png";